// Single source of truth for the "is this row part of the SQC series/calcs?"
// rule, shared by src/util/util.js (chart series) and src/util/instrumentStats.js
// (pure stats). Kept dependency-free (no React / MUI / Firebase imports) so
// instrumentStats stays unit-testable without rendering the component or mocking
// Firestore hooks, and so the omit rule can't drift between the two callers.
//
// A row is included in the SQC series/calculations unless it is omitted from SQC
// (`omitFromSqc === 'Y'`). Silenced rows (`silence === 'Y'`) are intentionally
// NOT excluded — silence only suppresses flags/notifications; the data stays in
// the series and calculations.
export const isIncludedInSqcChartSeries = (item) => String(item?.omitFromSqc).toUpperCase() !== 'Y';
